var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84961 7.5V3H6.84961V7.5H5.84961Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35012 9.70977C6.75012 9.70977 7.08012 9.38977 7.08012 8.98977C7.08012 8.58977 6.75012 8.25977 6.35012 8.25977C5.95012 8.25977 5.62012 8.58977 5.62012 8.98977C5.62012 9.38977 5.95012 9.70977 6.35012 9.70977Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35 0C2.85 0 0 2.85 0 6.35C0 9.85 2.85 12.7 6.35 12.7C9.85 12.7 12.7 9.85 12.7 6.35C12.7 2.85 9.85 0 6.35 0ZM6.35 11.7C3.4 11.7 1 9.3 1 6.35C1 3.4 3.4 1 6.35 1C9.3 1 11.7 3.4 11.7 6.35C11.7 9.3 9.3 11.7 6.35 11.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f255ffcbd5ccb5de755ecea9678c57b8.svg";
export { ForwardRef as ReactComponent };